<template>
    <div class="default-role">
        <b-card :title="$translate('default_role_notifications')" class="inner-page p-3">
            <b-card-body>
                <b-overlay :show="updating" rounded="sm">
                    <div class="mt-3 dd">
                        <b-form-select class="form-control" v-model="model_role_id" :options="roles" text-field="name"
                            value-field="id">
                            <template #first>
                                <b-form-select-option :value="null" disabled>{{ $translate('select_default_role')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="text-center mt-3">
                            <b-button id="update-role-btn" @click="updateRole" v-if="hasPermissionUpdate" size="fw" variant="info">{{ $updateLabel()
                            }}</b-button>
                        </div>
                    </div>
                </b-overlay>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'defaultRole',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        model_role_id: null,
        updating: false,
    }),

    computed: {
        componentName() { return this.$translate('default_role') },
        defaultRole() {
            const defaultRole = this.$store.getters['company/defaultRole']
            console.log('computed defaultRole', defaultRole)
            return defaultRole
        },

        defaultRoleKey() {
            return this.$store.state.company.settingKeys.defaultRoleKey
        },

        roles() {
            return this.$store.state.roles.items
        },
    },

    watch: {
        defaultRole: {
            handler: function (val) {
                console.log('watch defaultRole', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('roles/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.defaultRoleKey
        )
        this.$nextTick(() => {
            this.updateModel(this.defaultRole)
        })
    },

    methods: {
        updateModel(defaultRole) {
            this.model_role_id = defaultRole
        },
        async updateRole() {
            try {
                this.updating = true
                const text_value = this.model_role_id.toString()
                const bool_value = false

                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.defaultRoleKey,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`)

            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
